import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import {Link} from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import AsoMultiFilter from '../../filters/AsoMultiFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var BeatPlanDetailReportTable='';

class BeatPlanDetailReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            aso_names:"",
            download_limit:31,
            uid:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");


        //isReportAccess(AllAccessPermissions, 'GRD_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        const params = new URLSearchParams(this.props.location.search);

        const beatplan_date = decodeURIComponent(params.get('beatplan_date') || '');
        const aso_employeecode = decodeURIComponent(params.get('aso_employeecode') || '');
        const store_code = decodeURIComponent(params.get('store_code') || '');
        const store_name = decodeURIComponent(params.get('store_name') || '');
        this.get_filtered_beatpan_details_report(beatplan_date,aso_employeecode,store_code);
        this.setState({
            uid:this.props.match.params.id,
            beatplan_date:beatplan_date,
            aso_employeecode:aso_employeecode,
            store_code:store_code,
            store_name:store_name
            })
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
     downLoadPkycDocBeatPlanDetailReport (e){
        let filters = {
            uid: this.state.uid,
            report_code:'beat_plan_report_details',
            beatplan_date: this.state.beatplan_date,
            aso_employeecode: this.state.aso_employeecode,
            store_code: this.state.store_code,
            download: 1
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/sro_connectv2/aso_beatplan_utid_details','aso_beatplan_utid_details_report','');

    }

    get_filtered_beatpan_details_report(beatplan_date,aso_employeecode,store_code) {
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);
        var postData = {
            beatplan_date: beatplan_date,
            aso_employeecode:aso_employeecode,
            store_code: store_code,
            report_code:'beat_plan_report_details'
        };
        if ($.fn.DataTable.isDataTable('#BeatPlanDetailReportTable')) {
            $('#BeatPlanDetailReportTable').DataTable().clear().destroy();
        }

        BeatPlanDetailReportTable = $('#BeatPlanDetailReportTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "searching": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/aso_beatplan_utid_details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "ticket_id" },
                    { "data": "cf_utid" },
                    { "data": "cf_issue_sub_category" },
                    { "data": "ticket_type" },
                    { "data": "utid_ticket_status" },
                    { "data": "test_txn_status" },
                    { "data": "txn_mode" },
                    { "data": "software_version" },
                    { "data": "upgrade_software_version" },
                    { "data": "test_txn_timestamp" },
                    { "data": "transactionslip_status" },
                    { "data": "transactionslip_url" },
                    { "data": "transactionslip_upload_timestamp" },
                    { "data": "productstickerimage_status" },
                    { "data": "productstickerimage_url" },
                    { "data": "productstickerimage_upload_timestamp" },
                    { "data": "serialnumberimage_status" },
                    { "data": "serialnumberimage_url" },
                    { "data": "serialnumberimage_upload_timestamp" },
                    { "data": "oldserialnumberimage_status" },
                    { "data": "oldserialnumberimage_url" },
                    { "data": "oldserialnumberimage_upload_timestamp" },
                    { "data": "churnterminalimage_status" },
                    { "data": "churnterminalimage_url" },
                    { "data": "churnterminalimage_upload_timestamp" },
                    { "data": "churnaccessoriesimage_status" },
                    { "data": "churnaccessoriesimage_url" },
                    { "data": "churnaccessoriesimage_upload_timestamp" },
                    { "data": "terminalmissing_status" },
                    { "data": "terminalmissing_url" },
                    { "data": "terminalmissing_upload_timestamp" },
                    { "data": "adapter" },
                    { "data": "cable" },
                    { "data": "base_station" },
                    { "data": "stand" },
                    { "data": "jobsheet_status" },
                    { "data": "jobsheet_url" },
                    { "data": "store_photo_url"},
                    { "data": "store_selfie_url"},
                    { "data": "visit_started_at"},
                    { "data": "jobsheet_upload_timestamp" },

                    ],
                 "columnDefs": [

                  {
                        "targets": 4,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                        //console.log(td);
                            if (rowData.utid_ticket_status == 'Complete') {
                                $(td).addClass('doneLog');
                            }

                            else if (rowData.visit_status == 'NotStarted') {
                                $(td).addClass('failedLog');
                            }
                            else {
                                $(td).addClass('ongoingLog');
                            }
                        },
                    },
                {
                    "width": "50px",
                     "className":"text-center",
                    "targets": [11,14,17,20,23,26,29,36,37,38],
                    "data": "data",
                    "createdCell": (td, cellData, rowData, row, col) => {
                    $(td).text('');

                    // Map column index to its respective URL field
                    const urlFieldMap = {
                        11: 'transactionslip_url',
                        14: 'productstickerimage_url',
                        17: 'serialnumberimage_url',
                        20: 'oldserialnumberimage_url',
                        23: 'churnterminalimage_url',
                        26: 'churnaccessoriesimage_url',
                        29: 'terminalmissing_url',
                        36: 'jobsheet_url',
                        37: 'store_photo_url',
                        38: 'store_selfie_url'
                    };

                    const field = urlFieldMap[col];

                    if (rowData[field]) {
                        $(td).append('<a href="#" data-tip="View" title="Download" id="Download" class="RerunButton"><i class="fa fa-download"></i></a>');
                        $(td).click(e => {
                            this.download_doc(e, rowData[field]);
                        });
                    } else {
                        $(td).append('');
                    }


                    },
                    bSortable: false,
                },
                 {
                    render: function (data) {
                        if (data == '' || data == null || data == 'null') {
                            return "";
                        } else {
                            return "<div class='text-wrap width-80'>" + moment(data).format('D MMM YYYY HH:mm:ss') + "</div>";
                        }
                    },
                    "width": "80px",
                    "targets": [9,12,15,18,21,24,27,30,39,40]  // <- update with actual datetime column indexes
                }
               ],
            });


    }
    download_doc(e, rowData){


    axios.post(config.get('API_URL') + '/InternalReport/download-beatplan-image/',
        {
           file_path:rowData
        },
        {
            headers: {
                Authorization: `${localStorage.usertoken}`
            }
        }
    ).then(response => {
        console.log(response.data)
        if (response.data.error && response.data.error.trim() !== "") {
          alert(response.data.error);
        }
        const downloadLink = response.data.data;// Make sure your backend sends the link like { link: "https://..." }

        if (downloadLink) {
            const a = document.createElement('a');
            a.href = downloadLink;
            a.download = ''; // optional: set filename if you want
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            console.error("No download link in response.");
        }
    }).catch(error => {
        console.error("Download error:", error);
    });


    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.asoNameFilter.restAsoFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            aso_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleAsoEvents = (optionSelected, event_names) =>
    {
        this.setState({
            aso_names:event_names,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">{this.state.store_name} - ({this.state.store_code})</h4>
                                        <p className="category"><b>ASO Employee Code - {this.state.aso_employeecode}, Beat plan Date - {this.state.beatplan_date}</b></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-12"> */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label>Date Filter: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                 start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                             </div> */}
{/*                                             <div className="col-md-3 filter-bottom5 padd-5"> */}
{/*                                                 <label> ASO Name </label> */}
{/*                                                 <AsoMultiFilter ref="asoNameFilter" onSelectaso = {this.handleAsoEvents} /> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> */}
{/*                                              */}
{/*                                         </div> */}

{/*                                     </div> */}
{/*                                     <div className="row"> */}
{/*                                         <div className="col-md-5 pull-right"> */}
{/*                                             {this.state.isChange===true? */}
{/*                                                 <span className="apply-notification">Please click on Apply button</span>:null */}
{/*                                             } */}
{/*                                             <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_beatpan_details_report.bind(this)}>Apply</button> */}
{/*                                             <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button> */}
{/*                                         </div> */}
{/*                                     </div> */}


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton1" role="button" onClick={this.downLoadPkycDocBeatPlanDetailReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="BeatPlanDetailReportTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Ticket ID</th>
                                                <th>UTID</th>
                                                <th>Issue Sub Category</th>
                                                <th>Ticket Type</th>
                                                <th>UTID Ticket Status</th>
                                                <th>Test Txn Status</th>
                                                <th>Txn Mode</th>
                                                <th>Software Version</th>
                                                <th>Upgrade Software Version</th>
                                                <th>Test Txn Timestamp</th>
                                                <th>Transaction Slip Image Status</th>
                                                <th>Transaction Slip Image</th>
                                                <th>Transaction Slip Upload Timestamp</th>
                                                <th>Product Sticker Image Status</th>
                                                <th>Product Sticker Image </th>
                                                <th>Product Sticker Image Upload Timestamp</th>
                                                <th>Serial Number Image Status</th>
                                                <th>Serial Number Image </th>
                                                <th>Serial Number Image Upload Timestamp</th>
                                                <th>Old Serial Number Image Status</th>
                                                <th>Old Serial Number Image </th>
                                                <th>Old Serial Number Image Upload Timestamp</th>
                                                <th>Churn Terminal Image Status</th>
                                                <th>Churn Terminal Image </th>
                                                <th>Churn Terminal Image Upload Timestamp</th>
                                                <th>Churn Accessories Image Status</th>
                                                <th>Churn Accessories Image </th>
                                                <th>Churn Accessories Image Upload Timestamp</th>
                                                <th>Terminal Missing Status</th>
                                                <th>Terminal Missing </th>
                                                <th>Terminal Missing Upload Timestamp</th>
                                                <th>Adapter</th>
                                                <th>Cable</th>
                                                <th>Base Station</th>
                                                <th>Stand</th>
                                                <th>Job Sheet Status</th>
                                                <th>Job Sheet URL</th>
                                                <th>Store Photo URL</th>
                                                <th>Store Selfie URL</th>
                                                <th>Visit Started At</th>
                                                <th>Job Sheet Upload Timestamp</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(BeatPlanDetailReport)